export const COLLECTION_STAGES = [
  "none",
  "beginner",
  "intermediate",
  "advanced",
] as const;

export type CollectionStage = (typeof COLLECTION_STAGES)[number];

export const COLLECTION_STAGE_LABELS: Record<CollectionStage, string> = {
  none: "None",
  beginner: "Beginner",
  intermediate: "Intermediate",
  advanced: "Advanced",
};

/** User's current learning bucket (what they want to see / work on). */
export const USER_MASTERY_STAGES = [
  "all",
  "beginner",
  "intermediate",
  "advanced",
] as const;

export type UserMasteryStage = (typeof USER_MASTERY_STAGES)[number];

export const USER_MASTERY_STAGE_LABELS: Record<UserMasteryStage, string> = {
  all: "Show all",
  beginner: "Beginner",
  intermediate: "Intermediate",
  advanced: "Advanced",
};

export const MASTERY_STAGE_STORAGE_KEY = "masteryStagePreference";

export const normalizeCollectionStage = (
  stage: string | null | undefined,
): CollectionStage => {
  if (
    stage === "beginner" ||
    stage === "intermediate" ||
    stage === "advanced"
  ) {
    return stage;
  }
  return "none";
};

export const normalizeUserMasteryStage = (
  stage: string | null | undefined,
): UserMasteryStage => {
  if (
    stage === "beginner" ||
    stage === "intermediate" ||
    stage === "advanced" ||
    stage === "all"
  ) {
    return stage;
  }
  return "all";
};

export const getCollectionStageLabel = (
  stage: string | null | undefined,
): string => COLLECTION_STAGE_LABELS[normalizeCollectionStage(stage)];

export const getUserMasteryStageLabel = (
  stage: string | null | undefined,
): string => USER_MASTERY_STAGE_LABELS[normalizeUserMasteryStage(stage)];

export const readStoredMasteryStage = (): UserMasteryStage =>
  normalizeUserMasteryStage(localStorage.getItem(MASTERY_STAGE_STORAGE_KEY));

export const writeStoredMasteryStage = (stage: UserMasteryStage): void => {
  localStorage.setItem(MASTERY_STAGE_STORAGE_KEY, stage);
};

/**
 * Bucket filter: when the user is on a specific stage, only show collections
 * tagged with that stage. Untagged (none) decks are hidden until "Show all".
 */
export const collectionMatchesUserMasteryStage = (
  collectionStage: string | null | undefined,
  userMasteryStage: UserMasteryStage,
): boolean => {
  if (userMasteryStage === "all") {
    return true;
  }
  return normalizeCollectionStage(collectionStage) === userMasteryStage;
};
